import { render, staticRenderFns } from "./ViewPurchaseOrder.vue?vue&type=template&id=5e3b1d30&scoped=true"
import script from "./ViewPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./ViewPurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./ViewPurchaseOrder.vue?vue&type=style&index=0&id=5e3b1d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3b1d30",
  null
  
)

export default component.exports